/**
 * The flag in `enabledFeatureFlags` with which a portal switches learning plans over from learning-academy to the
 * leerplatform (ADR 0008). Both backends read the same flag: the leerplatform refuses the writes before, the academy
 * after, so the player must follow it.
 */
export const LEARNING_PLAN_IN_LEERPLATFORM = 'learningPlanInLeerplatform';

/**
 * The base url of the learning-plan endpoints (`LearningPlan`, `LearningPlan/info`, `LearningPlan/ReEnroll` and
 * `workflow/definition`, `signal`, `kick`, `execute`): the leerplatform API once the portal has switched learning plans
 * over, the academy until then. The paths and bodies are the same on both. Digital learning stays with the academy.
 */
export const learningPlanApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[LEARNING_PLAN_IN_LEERPLATFORM]
        ? settings.apiUrl
        : settings.portalApiUrl;

/**
 * Resetting the progress of a user in a learning plan: the leerplatform once the portal has switched learning plans
 * over; until then the academy, which the UI reaches through the Catalog API.
 */
export const resetLearningPlanForParticipantUrl = (settings, targetId, idString) =>
    settings.enabledFeatureFlags?.[LEARNING_PLAN_IN_LEERPLATFORM]
        ? `${settings.apiUrl}/api/1.0/resetAllInstancesForParticipant/${targetId}?idString=${encodeURIComponent(idString)}`
        : `${settings.catalogApiUrl}/api/1.0/resetAllInstancesForParticipant/${settings.portalIdentifier}/${targetId}?idString=${encodeURIComponent(idString)}`;

/**
 * Whether a user has progress in a learning plan that a reset would remove: always the leerplatform, which reads the
 * instances from the Academy database whichever side runs them, so it does not follow the flag.
 */
export const participantHasLearningPlanInstanceUrl = (settings, targetId, idString) =>
    `${settings.apiUrl}/api/1.0/checkParticipantHasInstance/${targetId}?idString=${encodeURIComponent(idString)}`;

/**
 * Disabling a package (removing all assignments of its learning plans, optionally deactivating its active version): the
 * leerplatform once the portal has switched learning plans over, when the academy sends its package pages here. Until
 * then the academy's own management page does it, so there is no url.
 */
export const disablePackageUrl = (settings, catalogId, deactivate) =>
    settings.enabledFeatureFlags?.[LEARNING_PLAN_IN_LEERPLATFORM]
        ? `${settings.apiUrl}/api/1.0/packages/${encodeURIComponent(catalogId)}/disable?deactivate=${deactivate === true}`
        : null;
